import * as Luxon from 'luxon';
import {DateRange} from '../../Core/models/DateRange';

class DateUtility {
  static isEmptyDate = (date: Date | string | undefined | null) =>
    date !== undefined && date !== null && isNaN(Date.parse(date.toString()));

  static toFormattedDate = (date: Date | string | undefined | '') => {
    if (date !== '' && date !== undefined && date !== null && !DateUtility.isEmptyDate(date)) {
      return Luxon.DateTime.fromJSDate(new Date(date)).toFormat('MM/dd/yyyy');
    } else {
      return '';
    }
  };

  static toFormattedDateAsUtc = (date: Date | string | undefined | '') =>
    date !== '' && date !== undefined && date !== null && !DateUtility.isEmptyDate(date)
      ? Luxon.DateTime.fromJSDate(new Date(date), {zone: 'utc'}).toFormat('MM/dd/yyyy')
      : '';

  static toFormattedDateTime = (date: Date | string | undefined) =>
    date !== undefined && date !== null && !DateUtility.isEmptyDate(date)
      ? Luxon.DateTime.fromJSDate(new Date(date)).toLocaleString(Luxon.DateTime.DATETIME_SHORT)
      : '';

  static toFormattedDateRange = (dateRange: DateRange) =>
    !DateUtility.isEmptyDate(dateRange.startDate) || !DateUtility.isEmptyDate(dateRange.endDate)
      ? `${DateUtility.toFormattedDate(dateRange.startDate) || '?'} - ${DateUtility.toFormattedDate(
          dateRange.endDate
        ) || '?'}`
      : '';

  static toShortDateTimeWithSeconds = (date: Date | string | undefined) =>
    date !== undefined && date !== null && !DateUtility.isEmptyDate(date)
      ? Luxon.DateTime.fromISO(date.toString(), {zone: 'utc'})
          .toLocal()
          .toLocaleString(Luxon.DateTime.DATETIME_SHORT_WITH_SECONDS)
      : '';

  static toFormattedTimeDuration = (durationStartDate: Date | undefined, durationEndDate: Date | undefined) =>
    durationStartDate !== undefined &&
    durationEndDate !== undefined &&
    !DateUtility.isEmptyDate(durationStartDate) &&
    !DateUtility.isEmptyDate(durationEndDate)
      ? Luxon.Interval.fromDateTimes(new Date(durationStartDate), durationEndDate)
          .toDuration(['hours', 'minutes', 'seconds'])
          .toFormat('hh:mm')
      : '';
  static toFormattedDateAsEst = (date: string | undefined) =>
    date !== undefined && date !== null && !DateUtility.isEmptyDate(date)
      ? Luxon.DateTime.fromISO(date, {zone: 'America/New_York'}).toFormat('MM/dd/yyyy')
      : '';
  static toFormattedDateAsEstWithSeconds = (date: string | undefined) =>
    date !== undefined && date !== null && !DateUtility.isEmptyDate(date)
      ? Luxon.DateTime.fromISO(date, {zone: 'America/New_York'}).toFormat('MM/dd/yyyy HH:mm:ss')
      : '';

  static getAgeFromDob = (dateOfBirth: Date) => {
    const today = new Date();
    const birthDate = dateOfBirth;
    let ageNow = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      ageNow--;
    }
    const age = isNaN(ageNow) || ageNow < 0 ? 0 : ageNow;

    return age;
  };

  static toIsoDate = (date: Date) => Luxon.DateTime.fromJSDate(date).toISODate();
}

export default DateUtility;
